import { EProductVariantsCollection } from '@gelato-api-ui/core/e-commerce/types/e-product-variants-collection';
import { EProductVariant } from '@gelato-api-ui/core/e-commerce/e-product-variant';

export const hasProductsWithCustomization = (storeProductVariantsCollection: EProductVariantsCollection): boolean =>
  Object.values(storeProductVariantsCollection).some((v: EProductVariant): boolean => v.isCustomizable);
